import React from 'react';

// ====  Material UI
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';

// styled components
import {Img, Spacer} from '../styles/table_styles.js';
//icons
import ArrowLeft from '../images/left-50.png';
import ArrowRight from '../images/right-50.png';


const useStyles = makeStyles({
  table: {
    minWidth: 300
  }
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    fontFamily: 'Rubik',
    background: 'lightgray',
    color: theme.palette.common.black,
    fontWeight: "bold"
  },
  body: {
    fontFamily: 'Rubik',
    fontSize: 14,
    align: "center",
    fontWeight: "bold"
  },
}))(TableCell);


function createData(aspect, opinion, i){
  return {aspect, opinion, i};
};


const PairTable = (props) => {
  const classes = useStyles();

  let extractions = props.data.extractions

// rows is an array of pair dicts
  let rows = []
  extractions.forEach(function(extraction, i){
    if(extraction.opinion && extraction.aspect){
      let set = createData(extraction.aspect, extraction.opinion, i )
      rows.push(set)
    }
  })

  // let arrowleft = require('../images/arrow-left-50.png')


  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow className={classes.header}>
            <StyledTableCell align="center"> Aspect </StyledTableCell>
            <StyledTableCell >
            </StyledTableCell>
            <StyledTableCell align="center"> Opinion </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.i}>
              <StyledTableCell component="th" scope="row" align="center">
                {row.aspect.tag}
              </StyledTableCell>
              <StyledTableCell align="center">
                <Img  src={ArrowLeft} />
                <Spacer/>
                <Img src={ArrowRight} />
              </StyledTableCell>
              <StyledTableCell align="center">
                {row.opinion.tag}
              </StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default PairTable;
